

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {ResourceMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {MatTreeModule} from "@angular/material/tree";
import {ResourceComponent} from "./resource.component";
import {ResourceFormComponent} from "./resourceForm.component";
import {ResourceDetailsComponent} from "./resourceDetails.component";
import {TranslateModule} from "@ngx-translate/core";
import {SecurityModule} from "../security/security.module";
import {AllResourcesResolve} from "./resolvers/resources.resolve";
import {AllResourceTypesResolve} from "./resolvers/resourceTypes.resolve";
import {ResourceResolve} from "./resolvers/resource.resolve";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TrainingModule} from "../training/training.module";

@NgModule({
    declarations: [
        ResourceComponent,
        ResourceMainSidebarComponent,
        ResourceFormComponent,
        ResourceDetailsComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,
        SecurityModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        TrainingModule,
    ],
    providers: [
        AllResourcesResolve,
        AllResourceTypesResolve,
        ResourceResolve,
    ],
    bootstrap: [ResourceComponent, ResourceFormComponent]
})
export class ResourceModule { }
